export default __webpack_public_path__ + "static/media/tech.660d36e2.jpg";